<template>
  <v-container fluid class="ma-0 pa-0">
    <v-divider></v-divider>
    <v-subheader class="black--text text-subtitle-2">
      <v-icon color="red" class="mr-2">mdi-alert-circle-outline</v-icon>
      Contract Item Issues
    </v-subheader>
    <v-data-table 
      :headers="headers" 
      :items="items"
      :height="tableSize"
      :loading="loading"
      fixed-header
      :items-per-page="-1"
      :footer-props="{'items-per-page-options': [-1]}"
      dense>

      <template v-slot:[`item.case_cost`]="{ item }">
        <span class="font-weight-bold">
          {{ item.case_cost }}
        </span>
      </template>

      <template v-slot:[`item.contract_case_cost`]="{ item }">
          <span :class="(item.contract_case_cost === item.case_cost) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
            {{ item.contract_case_cost }}
          </span>
      </template>

      <template v-slot:[`item.qty_per_case`]="{ item }">
        <span class="font-weight-bold">
          {{ item.qty_per_case }}
        </span>
      </template>

      <template v-slot:[`item.contract_case_pack`]="{ item }">
        <span :class="(item.contract_case_pack === item.qty_per_case) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
          {{ item.contract_case_pack }}
        </span>
      </template>

      <template v-slot:[`item.awg_amap`]="{ item }">
        <span class="font-weight-bold">
          {{ item.awg_amap }}
        </span>
      </template>

      <template v-slot:[`item.contract_amap`]="{ item }">
        <span :class="(item.contract_amap === item.awg_amap) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
          {{ item.contract_amap }}
        </span>
      </template>

      <template v-slot:[`item.awg_eba`]="{ item }">
        <span class="font-weight-bold">
          {{ item.awg_eba }}
        </span>
      </template>

      <template v-slot:[`item.contract_eba`]="{ item }">
        <span :class="(item.contract_eba === item.awg_eba) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
          {{ item.contract_eba }}
        </span>
      </template>

      <template v-slot:[`item.linked_group`]="{ item }">
        <span v-if="item && item.linked_group">
          <v-btn icon color="red" class="ma-auto" 
            @click.stop="showLinkedItems(item)">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </span>
      </template>

      <template v-slot:[`item.is_disco`]="{ item }">
        <v-tooltip class="mx-auto" top v-if="item && item.is_disco === true">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              color="warning">
              <v-icon class="mx-auto">mdi-alert</v-icon>
            </v-btn>
          </template>
          <span>Item has been Discontinued</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.is_future_new`]="{ item }">
        <v-tooltip class="mx-auto" top v-if="item && item.is_future_new === true">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              color="warning">
              <v-icon class="mx-auto">mdi-alert</v-icon>
            </v-btn>
          </template>
          <span>Item is a Future New Item</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.tpr_unit_allowance`]="{ item }">
          <span :class="(item.tpr_unit_allowance > .1) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
            {{ item.tpr_unit_allowance }}
          </span>
      </template>
      <template v-slot:[`item.ad_unit_allowance`]="{ item }">
          <span :class="(item.ad_unit_allowance > .1) ? 'font-weight-bold green--text' : 'font-weight-bold error--text'">
            {{ item.ad_unit_allowance }}
          </span>
      </template>
    </v-data-table>
    <ContractLinkedItems
      v-if="linkedItemsModal"
      :value.sync="linkedItemsModal"
      :item="selectedItem"
      :currentItems="items"
      :readOnly="true"
      @cancel="linkedItemsModal = false">
    </ContractLinkedItems>
  </v-container>
</template>
<script>
import ContractUpload from '@/axios/contract-upload-endpoint.js'
import { displayAlert } from '@/mixins/alert'
import { utils } from '@/mixins/utils'
import { fullWidthTable } from '@/mixins/table'
const ContractLinkedItems = () => import('@/components/contracts/ContractLinkedItems.vue')
export default {
  data () {
    return {
      loading: false,
      nonTableHeight: 460,
      tableSize: '',
      items: [],
      selectedItem: null,
      linkedItemsModal: false,
      headerProps: {
        sortable: false, filterable: false, class: 'accent white--text'
      },
      formatFields: [
        'case_cost', 'contract_case_cost', 'contract_amap',
        'awg_amap', 'contract_eba', 'awg_eba'
      ]
    }
  },
  name: 'ContractExceptionItems',
  components: { ContractLinkedItems },
  mixins: [displayAlert, utils, fullWidthTable],
  props: {
    value: Boolean,
    selectedContract: Object
  },
  async created() {
    this.tableSize = window.innerHeight - this.nonTableHeight
    await this.getExceptionItems()
  },
  computed: {
    baseHeaders() {
      return [
        { text: 'Source', value: 'source_name' },
        { text: 'Item Id', value: 'item_id' },
        { text: 'UPC', value: 'upc' },
        { text: 'Description', value: 'description' },
        { text: 'Case Cost', value: 'case_cost', align: 'center' },
        { text: 'Contract Case Cost', value: 'contract_case_cost', align: 'center' },
        { text: 'Case Pack', value: 'qty_per_case', align: 'center' },
        { text: 'Contract Case Pack', value: 'contract_case_pack', align: 'center' },
        { text: 'AWG AMAP', value: 'awg_amap', align: 'center' },
        { text: 'Contract AMAP', value: 'contract_amap', align: 'center' },
        { text: 'AWG AMAP Start', value: 'awg_amap_start' },
        { text: 'AWG AMAP End', value: 'awg_amap_end' },
        { text: 'AWG EBA', value: 'awg_eba', align: 'center' },
        { text: 'Contract EBA', value: 'contract_eba', align: 'center' },
        { text: 'AWG EBA Start', value: 'awg_eba_start' },
        { text: 'AWG EBA End', value: 'awg_eba_end' },
        { text: 'Contract Promo Start', value: 'contract_promo_start' },
        { text: 'Contract Promo End', value: 'contract_promo_end' },
        { text: 'Linked Items', value: 'linked_group', align: 'center' },
        { text: 'Is Disco', value: 'is_disco', align: 'center' },
        { text: 'Is Future New', value: 'is_future_new', align: 'center' },
        { text: 'TPR Unit Allowance', value: 'tpr_unit_allowance', align: 'center' },
        { text: 'Ad Unit Allowance', value: 'ad_unit_allowance', align: 'center' }
      ].filter(header => {
        return this.oneExists(header.value)
      })
    },
    headers() {
      return this.baseHeaders.flatMap(header => {
        return { ...this.headerProps, ...header }
      })
    }
  },
  methods: {
    async getExceptionItems() {
      this.loading = true
      let items = []
      try {
        const { data } = await ContractUpload.getExceptionItems(this.selectedContract.upload_id)
        if (data?.length > 0) {
          items = data.map(item => this.formatItem(item))
        }
        this.items = items
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    formatItem(item) {
      const { 
        contract_amap, contract_eba, contract_promo_start, contract_promo_end,
        awg_amap_start, awg_amap_end, awg_eba_start, awg_eba_end, source 
      } = item
      item.source_name = this.$store.getters.getSourceName(source)
      if (contract_amap || contract_eba) {
        item.contract_promo_start = this.$config.formatDate(contract_promo_start)
        item.contract_promo_end = this.$config.formatDate(contract_promo_end)
        item.awg_amap_start = contract_amap ? this.$config.formatDate(awg_amap_start) : null
        item.awg_amap_end = contract_amap ? this.$config.formatDate(awg_amap_end) : null
        item.awg_eba_start = contract_eba ? this.$config.formatDate(awg_eba_start) : null
        item.awg_eba_end = contract_eba ? this.$config.formatDate(awg_eba_end) : null
      } else {
        item.contract_promo_start = null
        item.contract_promo_end = null
      }
      for (const field of this.formatFields) {
        let value = item[field]
        if (value != null) {
          item[field] = `$${this.$config.formatCurrency(value)}`
        }
      }
      return item
    },
    showLinkedItems(item) {
      this.selectedItem = item
      this.linkedItemsModal = true
    },
    oneExists(key) {
      return this.items.some(item => item && (item[key] != null && item[key] !== false))
    }
  }
}
</script>